import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

function TooltipProvider(
  props: React.ComponentProps<typeof TooltipPrimitive.Provider>,
) {
  return <TooltipPrimitive.Provider data-slot="tooltip-provider" {...props} />
}

function Tooltip(props: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />
}

function TooltipTrigger(
  props: React.ComponentProps<typeof TooltipPrimitive.Trigger>,
) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

const TooltipArrow = TooltipPrimitive.Arrow

type TooltipContentProps = React.ComponentProps<
  typeof TooltipPrimitive.Content
> & {
  disablePortal?: boolean
}

function TooltipContent(props: TooltipContentProps) {
  const {
    className,
    sideOffset = 0,
    disablePortal = false,
    children,
    ...contentProps
  } = props

  const content = (
    <TooltipPrimitive.Content
      data-slot="tooltip-content"
      sideOffset={sideOffset}
      className={className}
      {...contentProps}
    >
      <div className="ui-tooltip-content-inner">{children}</div>
      <TooltipArrow className="ui-tooltip-arrow" />
    </TooltipPrimitive.Content>
  )

  if (disablePortal) return content

  return <TooltipPrimitive.Portal>{content}</TooltipPrimitive.Portal>
}
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipArrow,
}
